/*
 * Kinn — Email capture
 *
 * The form posts to Shopify on our own domain as a real page submit, and
 * this file does two small things around that:
 *
 *   1. Asks Shopify to wire hCaptcha to the form (Shopify.captcha.protect),
 *      so the post carries a score. A post with no score is treated as
 *      suspicious and sent to Shopify's challenge page; with one, most
 *      people never see a captcha at all.
 *   2. Changes the button label while the submit is in flight.
 *
 * It does NOT intercept the submit or post by fetch. It used to, and that
 * silently failed for anyone Shopify chose to challenge: a fetch cannot
 * complete a captcha, and a fetch after hCaptcha has spent its token gets
 * "Invalid CAPTCHA token". The success state is rendered by Liquid from
 * form.posted_successfully? when Shopify sends her back with
 * ?customer_posted=true, and Shopify's own validation errors render the
 * same way. Nothing here is load-bearing.
 *
 * The button is never disabled: Shopify's captcha can hold the submit while
 * it fetches a token, and a disabled button would leave her with nothing
 * to press and no explanation.
 */
(function () {
  function protect(form) {
    try {
      if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect) {
        window.Shopify.captcha.protect(form);
      }
    } catch (e) {}
  }

  function init(root) {
    var form = root.querySelector('[data-kinn-capture-form]');
    var label = root.querySelector('[data-kinn-capture-label]');
    if (!form || form.dataset.kinnBound) return;
    form.dataset.kinnBound = 'true';

    if (document.readyState === 'complete') protect(form);
    else window.addEventListener('load', function () { protect(form); });

    var idle = label ? label.textContent : '';
    form.addEventListener('submit', function () {
      if (!label) return;
      label.textContent = 'Sending…';
      /* If the page is still here after this long, the submit did not
         leave (a captcha held it, or it was refused); give the button
         its name back so she can try again. */
      window.setTimeout(function () { label.textContent = idle; }, 8000);
    });
  }

  function initAll() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-kinn-capture]'))
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* The theme editor re-renders sections on every edit. */
  document.addEventListener('shopify:section:load', initAll);
})();
